import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';

function CurrencyValue({ currencyObject, onlyValue, defaultCurrency }) {
	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

	return (
		<div>
			{getCurrencySymbolV2(selectedCurrency, defaultCurrency, '11px', '11px')} {currencyObject ? numberFormatter.format(currencyObject[selectedCurrency === 'all' ? defaultCurrency : selectedCurrency]) : 'N/A'}
		</div>
	);
}

export default CurrencyValue;
